import {useTranslation} from 'react-i18next';
import logo from '../../assets/persnormal-full-logo.svg';
import './Contact.css';

const Contact = () => {
    const {t} = useTranslation();

    return (
        <section className="contact-page container">
            <h1>{t('contact.title')}</h1>
            <p className="contact-body">{t('contact_body')}</p>

            <a href="mailto:develop@persnormal.com" className="contact-email">
                <span className="contact-email-label">{t('contact.email_label')}</span>
                <span className="contact-email-address">
                    develop@persnormal.com
                    <span className="arrow" aria-hidden="true">→</span>
                </span>
            </a>

            <img className="contact-logo" src={logo} alt={t('company.logo_alt')}/>
        </section>
    );
};

export default Contact;
